import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-documentation',
  templateUrl: './privacy-documentation.component.html',
  styleUrls: ['./privacy-documentation.component.css']
})
export class PrivacyDocumentationComponent {

}
